export const getOpenMaintenanceGridColumns = () => {
  return [
    {
      field: 'issueId',
      title: 'ID',
      drill: true,
    },
    {
      field: 'statusName',
      title: 'Status',
    },
    {
      field: 'systemName',
      title: 'System',
    },
    {
      field: 'sourceName',
      title: 'Issue Source',
    },
    {
      field: 'alertCount',
      title: 'Alert Count',
    },
    {
      field: 'lastAlertDate',
      title: 'Date Last Alert',
    },
  ]
}

export const getFlightDeckEffectsGridColumns = () => {
  return [
    {
      field: 'errorType',
      title: 'Type',
    },
    {
      field: 'code',
      title: 'Code',
    },
    {
      field: 'timeStamp',
      title: 'Time Stamp',
    },
  ]
}

export const getFleetGridColumns = internalUser => {
  if (internalUser) {
    return [
      {
        field: 'airlineName',
        title: 'Airline',
      },
      {
        field: 'modelName',
        title: 'Platform',
      },
      {
        field: 'tailNumber',
        title: 'Tail',
        drill: true,
      },
      {
        field: 'lastConnectionDate',
        title: 'Last Connection',
      },
      {
        field: 'issueCount',
        title: 'MX & Alerts',
      },
    ]
  }
  return [
    {
      field: 'modelName',
      title: 'Platform',
    },
    {
      field: 'tailNumber',
      title: 'Tail',
      drill: true,
    },
    {
      field: 'lastConnectionDate',
      title: 'Last Connection',
    },
    {
      field: 'issueCount',
      title: 'Open Mx Recs',
    },
  ]
}

export const getFaultMsgCodesColumns = () => {
  return [
    {
      field: 'code',
      title: 'Code',
    },
    {
      field: 'flightPhase',
      title: 'Flight Phase',
    },
    {
      field: 'flightNumber',
      title: 'Flight #',
    },
    {
      field: 'state',
      title: 'State',
    },
    {
      field: 'timeStamp',
      title: 'Time Stamp',
    },
    {
      field: 'report',
      title: 'Report',
    },
    {
      field: 'visualize',
      title: 'Visualize',
    },
  ]
}

export const getFaultMsgDetailsColumns = () => {
  return [
    {
      field: 'code',
      title: 'Code',
    },
    {
      field: 'flightPhase',
      title: 'Flight Phase',
    },
    {
      field: 'state',
      title: 'State',
    },
    {
      field: 'persistence',
      title: 'Persistence',
    },
    {
      field: 'timeStamp',
      title: 'Time Stamp',
    },
    {
      field: 'visualize',
      title: 'Visualize',
    },
  ]
}
